import React from "react";
import "../components/AboutUs.css"; // make sure you have this file

function AboutUs() {
  return (
    <div className="about-container">
      <h1 className="about-title">About Us</h1>
      <p className="about-text">
        We are ready to teach you <strong>programming fundamentals</strong> and 
        <strong> problem solving</strong> in an easy and interactive way.  
      </p>
      <p className="about-text">
        Our mission is to <strong>inspire students</strong> and show that 
        programming is not just a skill — it’s a way of life.  
      </p>
      <p className="about-text">
        Learning to code will increase your <strong>thinking ability</strong>, 
        sharpen your <strong>IQ</strong>, and help you build real-world 
        problem-solving confidence.
      </p>
      <p className="about-text">
        At <strong>Gen Z Skills</strong>, we believe every student has the 
        potential to become a creative thinker and an efficient problem solver.  
        Join us and start your journey today 🚀.
      </p>
    </div>
  );
}

export default AboutUs;
